import React from "react";
import { Col, Row } from "react-bootstrap";

const SchuelerButtons = ({ setView }) => {

  return (
    <>
      <div>
        <h4>Gutachten</h4>
        <Row>
          <Col>
            <button
              className="btn btn-outline-dark"
              onClick={() => setView("formNew")}
            >
              Neues Gutachten anlegen
            </button>
          </Col>

        </Row>
      </div>
    </>
  );
};
export default SchuelerButtons;
